<script setup lang="ts">
import { useStore } from '@/stores/base';
import { TgWappenSvg, ShWappenSvg } from '@/helpers/images';

withDefaults(
    defineProps<{
        app: boolean
        small?: boolean
    }>(),
    {
        app: false,
        small: false,
    },
)

const store = useStore();

</script>

<template>
    <v-app-bar :app="app" class="kp-header" :class="store.state.config?.env ? store.state.config.env : ''">
        <img :src="TgWappenSvg" height="45" alt="Thurgau Wappen" style="margin-right: 5px;" />
        <img :src="ShWappenSvg" height="45" alt="Schaffhausen Wappen" class="mr-3" />
        <div>
            <h1 class="title">
                {{ $t('g_efp') }}
            </h1>
            <div class="subtitle">
                {{ $t('k_tg_sh') }}
            </div>
        </div>
    </v-app-bar>
</template>
